import { maskCurrency, maskDate, maskUnd } from 'utils/mask';

export const dadosFormatados = (movimentacoes: any) => {
  const resultado = movimentacoes?.map((itemMovi: any) => ({
    ...itemMovi,
    pesoBruto: maskUnd(itemMovi.pesoBruto) + ' KG',
    tempoArmazenagemContratado: itemMovi.tempoArmazenagemContratado + ' Dias',
    tempoRestante: itemMovi.tempoRestante ? itemMovi.tempoRestante + ' Dias' : '',
    vlrMercadoria: maskCurrency(itemMovi.vlrMercadoria),
    dtEmissao: itemMovi.dtEmissao,
    dtLancamento: itemMovi.dtLancamento,
  }));

  const dataExport = resultado.map((elm: any) => {
    let status;
    switch (elm.status) {
      case 'ANFC':
        status = 'Aguardando nota de cobertura';
        break;
      case 'CR':
        status = 'Cobertura Realizada';
        break;
      case 'NC':
        status = 'Não necessita cobertura';
        break;
      default:
        status = '';
        break;
    }
    return {
      'N° Único': elm.nuNota,
      Nota: elm.numNota,
      Status: status,
      'Data Lançamento': maskDate(elm.dtLancamento),
      'Data emissão': maskDate(elm.dtEmissao),
      'Inscrição estadual': elm.inscricaoEstadualParceiro,
      Depositante: elm.parceiro,
      Emitente: elm.emitente,
      'Pagador da Armazenagem': elm.pagadorArmazenagem,
      'Tempo Armazenagem Contratado': elm.tempoArmazenagemContratado,
      'Tempo Restante	': elm.tempoRestante,
      'Peso Bruto': elm.pesoBruto,
      'Valor da Mercadoria': elm.vlrMercadoria,
    };
  });

  return dataExport;
};
